import { MessageResponse } from "../../shared/fetch-data/fetch-data";

export interface SubscribePackages extends MessageResponse {
  headers: SubscriptionHeader[];
  product_packages: ProductPackage[];
  grouped_packages: GroupedPackage[];
  footers: SubscriptionFooter[];
}

interface SubscriptionHeader extends SubscriptionBanner {}

interface SubscriptionFooter extends SubscriptionHeader {}

interface SubscriptionBanner {
  id: number;
  title: string;
  description: string;
  link: string;
  banner: string;
  position: number;
}

export interface ProductPackage {
  id: number;
  name: string;
  short_description: string;
  sku: string;
  price: number;
  price_show: number;
  avatar: {
    xxxdpi: string;
    xxhdpi: string;
    xhdpi: string;
    hdpi: string;
    mdpi: string;
  };
  feature_avatar: {
    xxxdpi: string;
    xxhdpi: string;
    xhdpi: string;
    hdpi: string;
    mdpi: string;
  };
  price_unit: string;
  view_type: "product" | "file" | "collection" | "super_collection";
  position: number;
  json_content?: JsonContent;
  payment_types: PaymentType[];
  is_purchasable?: boolean;
}

interface JsonContent {
  style_config?: StyleConfig;
}

export interface StyleConfig {
  alert?: boolean;
  alert_message?: string;
  expand?: boolean;
  expand_message?: string;
  title_is_bold?: boolean;
  title_color?: string;
  description_color?: string;
  background_color?: string;
  price_color?: string;
  priceshow_color?: string;
}

interface GroupedPackage {
  title: string;
  position: number;
  payment_type: PaymentType;
  product_packages: ProductPackage[];
}

interface PaymentType {
  id: number;
  payment_type: string;
  title: string;
  description: string;
  text_msg: string;
  avatar: string;
}

export enum PAYMENT_METHOD {
  SHAPARAK = 2,
  SADAD = 16,
  PAYMAN = 21,
  YEKPAY = 17
}

export interface SubscribeConfigeResponse {
  id: number;
  operator: "WEB";
  version: string;
  download_url: string;
  is_force: boolean;
  json_content: any;
  message: string;
  about: string;
  payment_flow: number;
  store: number;
  ads_rate: number;
}

interface PaymentInfo {
  sku: string;
  payment_type: PAYMENT_METHOD;
}
export interface ISPInfo {
  name: string;
  color: string;
  icon: string;
  sub_net_rate: "نیم بها";
  nosub_net_rate: "تمام بها";
  description: "کاربر ایرانسل شما می توانید بدون پرداخت هزینه از تمامی امکانات دیجیتون استفاده کنید که در این صورت حجم مصرفی اینترنت شما تمام بها محاسبه می شود.\r\nدر صورت خرید اشتراک حجم مصرفی اینترنت برای شما نیم بها خواهد بود.";
  net_rate: "تمام بها";
  net_rate_id: 3;
}

export const PurchaseType = {
  SHAPARAK_CODE: 2,
  CHARKHUNE_CODE: 5,
  BAZAR_CODE: 8,
  GIFT_CODE: 9,
  RESELLER_CODE: 14,
  SADAD_CODE: 16,
  FREE_PACKAGE_CODE: 18,
  CARD_TO_CARD_CODE: 20,
  MYKET_CODE: 22,
  VANDAR_CODE:  24,
}
